module.exports = __webpack_public_path__ + "img/default_products.774df5e0.svg";